import axiosInstance from '../../../redux/axiosInstance/';

class TaxServiceCategoryService {

  listCategories(page = 1, perPage = 100, search = '') {
    const params = { page, perPage };
    if (search) params.search = search;
    return axiosInstance.get('/tax-services/tax-service-categories/list', { params });
  }

  getCategoryBySlug(slug) {
    return axiosInstance.get(`/tax-services/tax-service-categories/view/${slug}`);
  }

  createCategory(data) {
    return axiosInstance.post('/tax-services/tax-service-categories/admins/create', data);
  }

  updateCategory(slug, data) {
    return axiosInstance.patch(`/tax-services/tax-service-categories/admins/update/${slug}`, data);
  }

  deleteCategory(slug) {
    return axiosInstance.delete(`/tax-services/tax-service-categories/admins/delete/${slug}`);
  }
}

export default new TaxServiceCategoryService();
